// extracted by mini-css-extract-plugin
module.exports = {"root":"image_root__vifuY"};